module.exports = __webpack_public_path__ + "goback_1.png?02761e47b44f11b0fda30ab3502ad8c9";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/goback_1.png
// module id = 6
// module chunks = 0